interface Props {
    alt: string;
    url?: string;
    className?: string;
}

export const ProfileImage = ({ alt, url, className }: Props) => {
    return <img className={className ?? 'profile-icon'} src={url ? url : '/img/header/user.svg'} alt={alt} />;
};
